import { getAccessToken } from 'Utils/auth';

// Shared fetch() wrapper for the endpoints that don't go through the axios
// clients in coreClient.ts/consoleClient.ts. Attaches the same
// `Authorization: Bearer <token>` header every caller was previously
// building by hand. Returns the raw Response — callers still decide how to
// interpret res.ok / res.json(), same as before this existed.
export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = await getAccessToken();
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
}
